<div class="bottom-nav-menu">
    <ul class="bottom-nav-menu-ul">
        <li class="bottom-nav-menu-li">
            <a
                class="bottom-nav-menu-a"
                routerLink="/sports"
                routerLinkActive="active-parent"
                [routerLinkActiveOptions]="{ exact: true }">
                <div class="bottom-nav-menu-img">
                    <img
                        src="../../../assets/footer-img/home.svg"
                        width="22"
                        height="22" />
                </div>
                <span class="bottom-nav-menu-span">
                    {{ 'footer_mobile.home_menu' | transloco }}
                </span>
            </a>
        </li>
        <li class="bottom-nav-menu-li">
            <a
                class="bottom-nav-menu-a"
                routerLink="/live"
                routerLinkActive="active-parent">
                <div class="bottom-nav-menu-img">
                    <img
                        src="../../../assets/footer-img/live.svg"
                        width="22"
                        height="22" />
                </div>
                <span class="bottom-nav-menu-span">
                    {{ 'footer_mobile.live_menu' | transloco }}
                </span>
            </a>
        </li>
        <li class="bottom-nav-menu-li">
            <a
                class="bottom-nav-menu-a"
                routerLink="/sport"
                routerLinkActive="active-parent">
                <div class="bottom-nav-menu-img">
                    <img
                        src="../../../assets/footer-img/sports.svg"
                        width="22"
                        height="22" />
                </div>
                <span class="bottom-nav-menu-span">
                    {{ 'footer_mobile.sports_menu' | transloco }}
                </span>
            </a>
        </li>
        <li class="bottom-nav-menu-li position-relative">
            <a
                class="bottom-nav-menu-a"
                [class.active-parent]="isMyBets"
                (click)="goToMyBets()">
                <div class="bottom-nav-menu-img">
                    <img
                        src="../../../assets/footer-img/my-bets.svg"
                        width="22"
                        height="22" />
                </div>
                <span
                    class="bottom-nav-menu-span"
                    [class.active]="isMyBets">
                    {{ 'footer_mobile.my_bets_menu' | transloco }}
                </span>
            </a>
            @if (user$ | async; as user) {
                @if (user.openBetsCount && user.openBetsCount > 0) {
                    <span class="open-bets-count">
                        {{ user?.openBetsCount }}
                    </span>
                }
            }
        </li>
        <li class="bottom-nav-menu-li">
            <a
                class="bottom-nav-menu-a"
                data-bs-target="#eventsp"
                routerLink="/search"
                routerLinkActive="active-parent">
                <div class="bottom-nav-menu-img">
                    <img
                        src="../../../assets/footer-img/search.svg"
                        width="22"
                        height="22" />
                </div>
                <span class="bottom-nav-menu-span">
                    {{ 'footer_mobile.explore_menu' | transloco }}
                </span>
            </a>
        </li>
        <li class="bottom-nav-menu-li chips">
            <a
                routerLink="/casino"
                routerLinkActive="active-parent"
                class="bottom-nav-menu-a chips">
                <div class="bottom-nav-menu-img-chip">
                    <img
                        width="25px"
                        height="25px"
                        src="/assets/images/footer/chip-gif-svg.svg" />
                </div>
            </a>
        </li>
        @if (!isMyBets) {
            <app-betslip-modal-mobile></app-betslip-modal-mobile>
        }
    </ul>
</div>
